import * as React from 'react';
const SvgSearch = () => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m20.47 21.53.53.53L22.06 21l-.53-.53-1.06 1.06Zm-4.65-6.77a.75.75 0 1 0-1.06 1.06l1.06-1.06Zm5.71 5.71-5.71-5.71-1.06 1.06 5.71 5.71 1.06-1.06ZM16.65 10.2a6.45 6.45 0 0 1-6.45 6.45v1.5a7.95 7.95 0 0 0 7.95-7.95h-1.5Zm-6.45 6.45a6.45 6.45 0 0 1-6.45-6.45h-1.5a7.95 7.95 0 0 0 7.95 7.95v-1.5ZM3.75 10.2a6.45 6.45 0 0 1 6.45-6.45v-1.5a7.95 7.95 0 0 0-7.95 7.95h1.5Zm6.45-6.45a6.45 6.45 0 0 1 6.45 6.45h1.5a7.95 7.95 0 0 0-7.95-7.95v1.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgSearch;
